import { NavLink } from "react-router-dom";
import type { SiteLinkProps } from "@quintara/site-kit";

// Adapter that lets @quintara/site-kit components navigate via react-router on
// the public website. Uses NavLink (not Link) so the shared header nav keeps its
// active-state highlight — NavLink appends an "active" class to the given
// className when its `to` matches the current route.
export function RouterLink({ to, className, style, children }: SiteLinkProps) {
  return (
    <NavLink to={to} className={className} style={style}>
      {children}
    </NavLink>
  );
}
